var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"progress-container\"><progress ng-attr-value=\"{{vm.progress || 0}}\" ng-class=\"vm.statusMap\" max=\"100\" class=\"progress native\"></progress><div class=\"progress-data\">{{ (vm.progress || 0) | number:1 }}%</div></div>");;return buf.join("");
}